module.exports = __webpack_public_path__ + "static/media/icon-manage-class-lup.e5348dcc.svg";